import { useTranslation } from 'react-i18next'

const PartnersSection = () => {
	const partners = [
		// { img: '/partners/dsdconsulting.png', url: 'https://www.dsdconsulting.ch' },
		{ img: '/partners/keramzit-pro-partner.png', url: 'https://keramzit.pro' },
		{ img: '/partners/ххп.png', url: 'https://kharkiv-himprom.com' }
	]

	const { t } = useTranslation()

	return (
		<section className='partners-section'>
			<div className='title'>
				<h1>
					{t('partnersSection.title')}{' '}
					<span className='text-[#65a665] pl-[10px]'>
						{t('partnersSection.highlight')}
					</span>
				</h1>
			</div>

			<div className='partners'>
				{partners.map((partner, i) => (
					<div key={i} className='partner' onClick={() => window.open(partner.url, '_blank')}>
						<img src={partner.img} alt={partner.img.substring(partner.img.lastIndexOf('/') + 1)} />
					</div>
				))}
			</div>
		</section>
	)
}

export default PartnersSection
